var map = {
	"./aed.png": 662,
	"./aud.png": 663,
	"./bgn.png": 664,
	"./bhd.png": 665,
	"./cad.png": 666,
	"./chf.png": 667,
	"./cnh.png": 668,
	"./cny.png": 669,
	"./czk.png": 670,
	"./dkk.png": 671,
	"./eur.png": 672,
	"./gbp.png": 673,
	"./hkd.png": 674,
	"./hrk.png": 675,
	"./huf.png": 676,
	"./idr.png": 677,
	"./ils.png": 678,
	"./inr.png": 679,
	"./jpy.png": 680,
	"./kes.png": 681,
	"./kwd.png": 682,
	"./mxn.png": 683,
	"./myr.png": 684,
	"./nok.png": 685,
	"./nzd.png": 686,
	"./omr.png": 687,
	"./php.png": 688,
	"./pln.png": 689,
	"./qar.png": 690,
	"./ron.png": 691,
	"./rub.png": 692,
	"./sar.png": 693,
	"./sek.png": 694,
	"./sgd.png": 695,
	"./thb.png": 696,
	"./try.png": 697,
	"./ugx.png": 698,
	"./usd.png": 699,
	"./zar.png": 700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;